
import { Product } from '@/types/portfolio';

// Mock products for Green Seal certified directory
export const mockGreenSealProducts: Partial<Product>[] = [
  {
    id: 'gs-product-01',
    name: 'EcoClean All-Purpose Cleaner',
    description: 'Plant-based multi-surface cleaner that effectively removes dirt, grease, and grime without harsh chemicals. Safe for use around children and pets.',
    product_type: 'cleaning_product',
    manufacturer: 'Green Solutions Inc.',
    certification_status: 'certified',
    portfolio_id: 'mock-portfolio-1'
  },
  {
    id: 'gs-product-02', 
    name: 'BioFresh Dishwashing Liquid',
    description: 'Concentrated dish soap made from renewable plant sources. Cuts through grease while being gentle on hands and the environment.',
    product_type: 'cleaning_product',
    manufacturer: 'Natural Clean Co.',
    certification_status: 'certified',
    portfolio_id: 'mock-portfolio-1'
  },
  {
    id: 'gs-product-03',
    name: 'Pure Toilet Paper - 2-Ply',
    description: '100% recycled fiber toilet paper with no chlorine bleaching. Soft, strong, and environmentally responsible.',
    product_type: 'paper_product',
    manufacturer: 'Sustainable Paper Mills',
    certification_status: 'certified',
    portfolio_id: 'mock-portfolio-1'
  },
  {
    id: 'gs-product-04',
    name: 'Natural Glass & Window Cleaner',
    description: 'Streak-free glass cleaner using plant-derived ingredients. No ammonia or harsh fumes.',
    product_type: 'cleaning_product',
    manufacturer: 'Clear View Products',
    certification_status: 'certified',
    portfolio_id: 'mock-portfolio-1'
  },
  {
    id: 'gs-product-05',
    name: 'Recycled Copy Paper - 20lb',
    description: 'High-quality office paper made from 100% post-consumer recycled content. Excellent print quality for all office needs.',
    product_type: 'paper_product',
    manufacturer: 'EcoOffice Supplies',
    certification_status: 'certified',
    portfolio_id: 'mock-portfolio-1'
  },
  {
    id: 'gs-product-06',
    name: 'Citrus Degreaser Concentrate',
    description: 'Heavy-duty degreaser made with natural citrus oils. Biodegradable formula for industrial and commercial use.',
    product_type: 'cleaning_product',
    manufacturer: 'Industrial Green Solutions',
    certification_status: 'certified',
    portfolio_id: 'mock-portfolio-1'
  },
  {
    id: 'gs-product-07',
    name: 'Bamboo Paper Towels',
    description: 'Absorbent paper towels made from rapidly renewable bamboo fiber. Strong when wet, gentle on surfaces.',
    product_type: 'paper_product',
    manufacturer: 'Bamboo Essentials',
    certification_status: 'certified',
    portfolio_id: 'mock-portfolio-1'
  },
  {
    id: 'gs-product-08',
    name: 'Natural Floor Cleaner',
    description: 'pH-neutral floor cleaner safe for all hard surface floors. Made with plant-based surfactants and essential oils.',
    product_type: 'cleaning_product',
    manufacturer: 'FloorCare Naturals',
    certification_status: 'certified',
    portfolio_id: 'mock-portfolio-1'
  },
  {
    id: 'gs-product-09',
    name: 'Eco-Friendly Fabric Softener',
    description: 'Plant-based fabric softener that naturally softens clothes without synthetic fragrances or dyes. Hypoallergenic formula.',
    product_type: 'laundry_product',
    manufacturer: 'Gentle Care Products',
    certification_status: 'certified',
    portfolio_id: 'mock-portfolio-1'
  }
];

// Chemical safety data for the products
export const mockChemicalSafetyData = {
  'gs-product-01': {
    concernLevel: 'low' as const,
    warningIcons: [] as const
  },
  'gs-product-02': {
    concernLevel: 'low' as const,
    warningIcons: [] as const
  },
  'gs-product-03': {
    concernLevel: 'low' as const,
    warningIcons: [] as const
  },
  'gs-product-04': {
    concernLevel: 'low' as const,
    warningIcons: [] as const
  },
  'gs-product-05': {
    concernLevel: 'low' as const,
    warningIcons: [] as const
  },
  'gs-product-06': {
    concernLevel: 'moderate' as const,
    warningIcons: ['skin'] as const
  },
  'gs-product-07': {
    concernLevel: 'low' as const,
    warningIcons: [] as const
  },
  'gs-product-08': {
    concernLevel: 'low' as const,
    warningIcons: [] as const
  },
  'gs-product-09': {
    concernLevel: 'low' as const,
    warningIcons: [] as const
  }
};
